<template>
  <!-- 栅格布局方式
       @author: 王汝鹏
       @date: 2019-9-13
   -->
  <div class="setting-item">
    <el-form-item label="标题设置"> 
      <el-select class="setting-grid-justify" v-model="title">
        <el-option value="18" label="一级标题"></el-option>
        <el-option value="14" label="二级标题"></el-option>
        <el-option value="12" label="正文"></el-option>
      </el-select>
    </el-form-item>
  </div>
</template>

<script>
// 导入value监听混入
import mixValueWatch from '@/mixins/common/mix_value_watch.js';
// 导入计算属性映射方法
import { mapComputed } from '@/mixins/common/mix_value_watch.js';
export default {
  mixins: [ mixValueWatch ],
  computed: {
    /**
     * @name 标题
     * @author liuguisheng
     * @version 2020-05-23 星期六
     */
    ...mapComputed({
      title: { 
        parent: i => i.styleOption,
        attr: "title" 
      }
    }),
  },
}
</script>


// WEBPACK FOOTER //
// src/components/Setting/base_setting/SettingTextTitle.vue